import React from 'react'
import { styled, useTheme } from '@mui/material'
import PropTypes from 'prop-types'
import {
  Box,
  Modal,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '../../../../../components/mui/Core/index'
import SubHeader from '../../../../../components/SubHeader/sub-header'
import Constants from '../../../../../constants/en.json'
import Ellipse from '../../../../../components/genericcomponents/Ellipse/ellipse'

const CenteredContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
}))

function DeleteRoleModal({ isOpen, selectedRoleToDelete, handleCloseAction, onConfirm }) {
  const theme = useTheme()

  const containerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '496px',
    bgcolor: theme.palette.common.white,
    boxShadow: 24,
    padding: '10px 20px 10px 25px',
    border: 'none !important',
    borderRadius: '12px',
  }

  const cardBodyStyle = {
    paddingTop: '15px',
    color: theme.palette.common.black,
    fontFamily: 'AtlasGroteskRegular',
    fontSize: '16px',
    lineHeight: '20px',
  }

  const buttonsContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: '10px',
    gap: '10px',
  }

  const userListStyle = {
    padding: '10px 0',
    '& li': {
      paddingBottom: '0px',
      paddingTop: '0px',
      '& .MuiListItemIcon-root': {
        alignSelf: 'flex-start',
        minWidth: '15px',
        paddingTop: '12px',
      },
      '& .MuiListItemText-root': {
        marginTop: '5px',
        marginBottom: '10px',
      },
    },
  }

  const listTextStyle = {
    color: theme.palette.common.black,
    fontFamily: 'AtlasGroteskRegular',
    fontSize: '16px',
    lineHeight: '20px',
  }

  return (
    <Modal open={isOpen} onClose={handleCloseAction}>
      <CenteredContainer>
        <Box sx={containerStyle}>
          <SubHeader title={Constants.roleManagement.deleteRole.DELETE_ROLE} />
          <Typography sx={cardBodyStyle}>
            {Constants.roleManagement.deleteRole.CONFIRM_DELETE_ROLE}
          </Typography>

          <List sx={userListStyle}>
            <ListItem disablePadding>
              <ListItemIcon>
                <Ellipse />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={listTextStyle}
                primary={selectedRoleToDelete?.code}
              />
            </ListItem>
          </List>

          <Box sx={buttonsContainerStyle}>
            <Button variant='outlined' color='secondary' onClick={handleCloseAction}>
              {Constants.roleManagement.deleteRole.CANCEL}
            </Button>
            <Button color='error' variant='contained' onClick={onConfirm}>
              {Constants.roleManagement.deleteRole.DELETE}
            </Button>
          </Box>
        </Box>
      </CenteredContainer>
    </Modal>
  )
}

DeleteRoleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  selectedRoleToDelete: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      application: PropTypes.string.isRequired,
      dateCreated: PropTypes.string.isRequired,
      dateModified: PropTypes.string.isRequired,
      modifiedBy: PropTypes.string.isRequired,
    }),
    PropTypes.oneOf([null]),
  ]),
  handleCloseAction: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default DeleteRoleModal
